module.exports = __webpack_public_path__ + "static/media/21ECLAC39.9aded168.jpg";